var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KisweButton',{staticClass:"kiswe-copy-button",class:{
    'kiswe-copy-button--copied': _vm.isCopied,
    'kiswe-copy-button--copied-background': _vm.isCopied && _vm.hasCopiedBackground
  },attrs:{"theme":_vm.theme,"shape":_vm.shape,"size":_vm.size,"disabled":_vm.disabled},on:{"click":_vm.copyToClipboard}},[_c('KisweIcon',{attrs:{"name":_vm.buttonIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }